import { axiosInstance } from "@/services/axiosInstance";

export const CanalDeVendasResource = {

  getSaleChannelNegotiation: parametros => {
    return axiosInstance.get("v1/salechannel/negotiation");
  },

  getLista: parametros => {
    return axiosInstance.get("v1/salechannel");
  },
  getCanalDeVenda: parametros => {
    return axiosInstance.get("v1/salechannel/:id", {
      urlParams: parametros
    });
  },
  cadastrarPoliticaComercial: parametros => {
    return axiosInstance.post("v1/salechannel/commercialpolicy", parametros);
  },
  atualizarPoliticaComercial: parametros => {
    console.log(parametros);
    return axiosInstance.put("v1/salechannel/commercialpolicy", parametros);
  },
  getListaPoliticaComercial: parametros => {
    return axiosInstance.get("v1/salechannel/commercialpolicy", {
      params: parametros
    });
  },
  getPoliticaComercial: parametros => {
    return axiosInstance.get("v1/salechannel/commercialpolicy/:id", {
      urlParams: parametros
    });
  },
  getKeyValue: parametros => {
    return axiosInstance.get("v1/salechannel/commercialpolicy", parametros);
  }
};
